import React from 'react'

import styles from './styles.module.scss'

interface IProps {
    count: number
    isSaving?: boolean
    onSave: () => void
    onCancel: () => void
}

const ImageRotateActionsBar = ({ count, isSaving = false, onSave, onCancel }: IProps) => {
    if (count === 0) {
        return null
    }

    return (
        <div className={styles.bar}>
            <span className={styles.label}>
                Изменено фото: {count}
            </span>
            <button type="button" className={styles.cancelButton} onClick={onCancel} disabled={isSaving}>
                Отменить
            </button>
            <button type="button" className={styles.saveButton} onClick={onSave} disabled={isSaving}>
                {isSaving ? 'Применение...' : 'Применить'}
            </button>
        </div>
    )
}

export default ImageRotateActionsBar
